import { PROVIDER } from 'Pods/ThreeDStudio/Store/constants'

export const MODELS = [
  { id: PROVIDER.NANO_BANANA, label: 'Nano Banana 2 Lite' },
  { id: PROVIDER.FLUX, label: 'Flux 2 Pro' },
]
